<script lang="ts">
    import ReviewsStorefrontValuesSettingsEntity from "@apps/reviews/entities/ReviewsStorefrontValuesSettingsEntity";
    import FormManager from "@lib/FormManager/FormManager";
    import { ValidationStrategy } from "@lib/FormManager/types";
    import yupResolver from "@lib/FormManager/yupResolver";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import * as Yup from "yup";

    import { stepperControllerContextToken } from "@components/Stepper/context_tokens";
    import T from "@components/T.svelte";

    import { REVIEWS_FORM_STEPS_NAMES } from "../../../constants";
    import ReviewsWizardManager from "../../../managers/ReviewsWizardManager";
    import GuestInfoForm from "./GuestInfoForm.svelte";

    export let isAuthenticated: boolean;
    export let reviewsWizardManager: ReviewsWizardManager;
    export let reviewsSettings: ReviewsStorefrontValuesSettingsEntity;

    const stepperController = getTypedContext(stepperControllerContextToken);

    const guestInfoFormManager = reviewsWizardManager.cacheManager.get(
        REVIEWS_FORM_STEPS_NAMES.GUEST_INFO,
        [],
        () => {
            return new FormManager({
                initialValues: {
                    guestName: "",
                    guestEmail: "",
                },
                unregisterOnUnmount: false,
                resolver: yupResolver(
                    Yup.object({
                        guestName: Yup.string().required(
                            "validation_field_required"
                        ),
                        guestEmail: Yup.string()
                            .email("validation_email")
                            .required("validation_field_required"),
                    })
                ),
                validationStrategy: ValidationStrategy.OnSubmit,
                onSubmit: ({ values, errors }) => {
                    if (!values || (errors && Object.values(errors).length > 0))
                        return;

                    reviewsWizardManager.collectFormData(values);
                    reviewsWizardManager.submitCollectedFormData();
                },
            });
        }
    );

    const setNavButtons = () => {
        reviewsWizardManager.setNextButton({
            type: "submit",
            isActive: true,
            onClick: () => {
                guestInfoFormManager.submit();
            },
        });
        reviewsWizardManager.setPrevButton({
            type: "prev",
            isActive: true,
            onClick: () => {
                stepperController.prevStep();
            },
        });
    };

    setNavButtons();
</script>

<div class="gw-rv-form-user">
    <h2 class="gw-rv-form-user__title">
        <T
            namespace="reviews.ReviewsFormModalWidget"
            translationKey="guest_step_title"
        />
    </h2>

    <div class="gw-rv-form-user__inputs">
        <GuestInfoForm
            {guestInfoFormManager}
            {reviewsSettings}
            {isAuthenticated}
        />
    </div>
</div>

<style lang="postcss">
    .gw-rv-form-user {
        width: 570px;

        &__title {
            font-size: 1.8em;
            line-height: 1.2;
            font-weight: 600;
            margin: 0;
            text-align: center;
        }

        &__inputs {
            margin-top: 2em;
        }
    }
</style>
